// 国家电话区号列表（按国家名称字母顺序排列）
export const countryCodes = [
  { value: '+93', label: '🇦🇫 +93', flag: '🇦🇫', country: 'Afghanistan' },
  { value: '+355', label: '🇦🇱 +355', flag: '🇦🇱', country: 'Albania' },
  { value: '+213', label: '🇩🇿 +213', flag: '🇩🇿', country: 'Algeria' },
  { value: '+1', label: '🇦🇸 +1', flag: '🇦🇸', country: 'American Samoa' },
  { value: '+376', label: '🇦🇩 +376', flag: '🇦🇩', country: 'Andorra' },
  { value: '+244', label: '🇦🇴 +244', flag: '🇦🇴', country: 'Angola' },
  { value: '+1', label: '🇦🇮 +1', flag: '🇦🇮', country: 'Anguilla' },
  { value: '+1-268', label: '🇦🇬 +1-268', flag: '🇦🇬', country: 'Antigua and Barbuda' },
  { value: '+54', label: '🇦🇷 +54', flag: '🇦🇷', country: 'Argentina' },
  { value: '+374', label: '🇦🇲 +374', flag: '🇦🇲', country: 'Armenia' },
  { value: '+297', label: '🇦🇼 +297', flag: '🇦🇼', country: 'Aruba' },
  { value: '+247', label: '🇦🇨 +247', flag: '🇦🇨', country: 'Ascension Island' },
  { value: '+61', label: '🇦🇺 +61', flag: '🇦🇺', country: 'Australia' },
  { value: '+672', label: '🇦🇶 +672', flag: '🇦🇶', country: 'Australian External Territories' },
  { value: '+43', label: '🇦🇹 +43', flag: '🇦🇹', country: 'Austria' },
  { value: '+994', label: '🇦🇿 +994', flag: '🇦🇿', country: 'Azerbaijan' },
  { value: '+1-242', label: '🇧🇸 +1-242', flag: '🇧🇸', country: 'Bahamas' },
  { value: '+973', label: '🇧🇭 +973', flag: '🇧🇭', country: 'Bahrain' },
  { value: '+880', label: '🇧🇩 +880', flag: '🇧🇩', country: 'Bangladesh' },
  { value: '+1-246', label: '🇧🇧 +1-246', flag: '🇧🇧', country: 'Barbados' },
  { value: '+375', label: '🇧🇾 +375', flag: '🇧🇾', country: 'Belarus' },
  { value: '+32', label: '🇧🇪 +32', flag: '🇧🇪', country: 'Belgium' },
  { value: '+501', label: '🇧🇿 +501', flag: '🇧🇿', country: 'Belize' },
  { value: '+229', label: '🇧🇯 +229', flag: '🇧🇯', country: 'Benin' },
  { value: '+1-441', label: '🇧🇲 +1-441', flag: '🇧🇲', country: 'Bermuda' },
  { value: '+975', label: '🇧🇹 +975', flag: '🇧🇹', country: 'Bhutan' },
  { value: '+591', label: '🇧🇴 +591', flag: '🇧🇴', country: 'Bolivia' },
  { value: '+599', label: '🇧🇶 +599', flag: '🇧🇶', country: 'Bonaire, Sint Eustatius and Saba' },
  { value: '+387', label: '🇧🇦 +387', flag: '🇧🇦', country: 'Bosnia and Herzegovina' },
  { value: '+267', label: '🇧🇼 +267', flag: '🇧🇼', country: 'Botswana' },
  { value: '+246', label: '🇮🇴 +246', flag: '🇮🇴', country: 'British Indian Ocean Territory' },
  { value: '+55', label: '🇧🇷 +55', flag: '🇧🇷', country: 'Brazil' },
  { value: '+673', label: '🇧🇳 +673', flag: '🇧🇳', country: 'Brunei' },
  { value: '+359', label: '🇧🇬 +359', flag: '🇧🇬', country: 'Bulgaria' },
  { value: '+226', label: '🇧🇫 +226', flag: '🇧🇫', country: 'Burkina Faso' },
  { value: '+257', label: '🇧🇮 +257', flag: '🇧🇮', country: 'Burundi' },
  { value: '+855', label: '🇰🇭 +855', flag: '🇰🇭', country: 'Cambodia' },
  { value: '+237', label: '🇨🇲 +237', flag: '🇨🇲', country: 'Cameroon' },
  { value: '+1', label: '🇨🇦 +1', flag: '🇨🇦', country: 'Canada' },
  { value: '+238', label: '🇨🇻 +238', flag: '🇨🇻', country: 'Cape Verde' },
  { value: '+1', label: '🇰🇾 +1', flag: '🇰🇾', country: 'Cayman Islands' },
  { value: '+236', label: '🇨🇫 +236', flag: '🇨🇫', country: 'Central African Republic' },
  { value: '+235', label: '🇹🇩 +235', flag: '🇹🇩', country: 'Chad' },
  { value: '+56', label: '🇨🇱 +56', flag: '🇨🇱', country: 'Chile' },
  { value: '+86', label: '🇨🇳 +86', flag: '🇨🇳', country: 'China' },
  { value: '+57', label: '🇨🇴 +57', flag: '🇨🇴', country: 'Colombia' },
  { value: '+269', label: '🇰🇲 +269', flag: '🇰🇲', country: 'Comoros' },
  { value: '+682', label: '🇨🇰 +682', flag: '🇨🇰', country: 'Cook Islands' },
  { value: '+242', label: '🇨🇬 +242', flag: '🇨🇬', country: 'Congo' },
  { value: '+243', label: '🇨🇩 +243', flag: '🇨🇩', country: 'Congo (DRC)' },
  { value: '+506', label: '🇨🇷 +506', flag: '🇨🇷', country: 'Costa Rica' },
  { value: '+225', label: '🇨🇮 +225', flag: '🇨🇮', country: 'Côte d\'Ivoire' },
  { value: '+385', label: '🇭🇷 +385', flag: '🇭🇷', country: 'Croatia' },
  { value: '+53', label: '🇨🇺 +53', flag: '🇨🇺', country: 'Cuba' },
  { value: '+599', label: '🇨🇼 +599', flag: '🇨🇼', country: 'Curaçao' },
  { value: '+357', label: '🇨🇾 +357', flag: '🇨🇾', country: 'Cyprus' },
  { value: '+420', label: '🇨🇿 +420', flag: '🇨🇿', country: 'Czech Republic' },
  { value: '+45', label: '🇩🇰 +45', flag: '🇩🇰', country: 'Denmark' },
  { value: '+246', label: '🇮🇴 +246', flag: '🇮🇴', country: 'Diego Garcia' },
  { value: '+253', label: '🇩🇯 +253', flag: '🇩🇯', country: 'Djibouti' },
  { value: '+1-767', label: '🇩🇲 +1-767', flag: '🇩🇲', country: 'Dominica' },
  { value: '+1-809', label: '🇩🇴 +1-809', flag: '🇩🇴', country: 'Dominican Republic' },
  { value: '+670', label: '🇹🇱 +670', flag: '🇹🇱', country: 'East Timor' },
  { value: '+593', label: '🇪🇨 +593', flag: '🇪🇨', country: 'Ecuador' },
  { value: '+20', label: '🇪🇬 +20', flag: '🇪🇬', country: 'Egypt' },
  { value: '+503', label: '🇸🇻 +503', flag: '🇸🇻', country: 'El Salvador' },
  { value: '+240', label: '🇬🇶 +240', flag: '🇬🇶', country: 'Equatorial Guinea' },
  { value: '+291', label: '🇪🇷 +291', flag: '🇪🇷', country: 'Eritrea' },
  { value: '+372', label: '🇪🇪 +372', flag: '🇪🇪', country: 'Estonia' },
  { value: '+268', label: '🇸🇿 +268', flag: '🇸🇿', country: 'Eswatini' },
  { value: '+251', label: '🇪🇹 +251', flag: '🇪🇹', country: 'Ethiopia' },
  { value: '+500', label: '🇫🇰 +500', flag: '🇫🇰', country: 'Falkland Islands' },
  { value: '+298', label: '🇫🇴 +298', flag: '🇫🇴', country: 'Faroe Islands' },
  { value: '+679', label: '🇫🇯 +679', flag: '🇫🇯', country: 'Fiji' },
  { value: '+358', label: '🇫🇮 +358', flag: '🇫🇮', country: 'Finland' },
  { value: '+33', label: '🇫🇷 +33', flag: '🇫🇷', country: 'France' },
  { value: '+594', label: '🇬🇫 +594', flag: '🇬🇫', country: 'French Guiana' },
  { value: '+689', label: '🇵🇫 +689', flag: '🇵🇫', country: 'French Polynesia' },
  { value: '+241', label: '🇬🇦 +241', flag: '🇬🇦', country: 'Gabon' },
  { value: '+220', label: '🇬🇲 +220', flag: '🇬🇲', country: 'Gambia' },
  { value: '+995', label: '🇬🇪 +995', flag: '🇬🇪', country: 'Georgia' },
  { value: '+49', label: '🇩🇪 +49', flag: '🇩🇪', country: 'Germany' },
  { value: '+233', label: '🇬🇭 +233', flag: '🇬🇭', country: 'Ghana' },
  { value: '+350', label: '🇬🇮 +350', flag: '🇬🇮', country: 'Gibraltar' },
  { value: '+30', label: '🇬🇷 +30', flag: '🇬🇷', country: 'Greece' },
  { value: '+299', label: '🇬🇱 +299', flag: '🇬🇱', country: 'Greenland' },
  { value: '+1-473', label: '🇬🇩 +1-473', flag: '🇬🇩', country: 'Grenada' },
  { value: '+590', label: '🇬🇵 +590', flag: '🇬🇵', country: 'Guadeloupe' },
  { value: '+1', label: '🇬🇺 +1', flag: '🇬🇺', country: 'Guam' },
  { value: '+502', label: '🇬🇹 +502', flag: '🇬🇹', country: 'Guatemala' },
  { value: '+224', label: '🇬🇳 +224', flag: '🇬🇳', country: 'Guinea' },
  { value: '+245', label: '🇬🇼 +245', flag: '🇬🇼', country: 'Guinea-Bissau' },
  { value: '+592', label: '🇬🇾 +592', flag: '🇬🇾', country: 'Guyana' },
  { value: '+509', label: '🇭🇹 +509', flag: '🇭🇹', country: 'Haiti' },
  { value: '+504', label: '🇭🇳 +504', flag: '🇭🇳', country: 'Honduras' },
  { value: '+852', label: '🇭🇰 +852', flag: '🇭🇰', country: 'Hong Kong' },
  { value: '+36', label: '🇭🇺 +36', flag: '🇭🇺', country: 'Hungary' },
  { value: '+354', label: '🇮🇸 +354', flag: '🇮🇸', country: 'Iceland' },
  { value: '+91', label: '🇮🇳 +91', flag: '🇮🇳', country: 'India' },
  { value: '+62', label: '🇮🇩 +62', flag: '🇮🇩', country: 'Indonesia' },
  { value: '+98', label: '🇮🇷 +98', flag: '🇮🇷', country: 'Iran' },
  { value: '+964', label: '🇮🇶 +964', flag: '🇮🇶', country: 'Iraq' },
  { value: '+353', label: '🇮🇪 +353', flag: '🇮🇪', country: 'Ireland' },
  { value: '+972', label: '🇮🇱 +972', flag: '🇮🇱', country: 'Israel' },
  { value: '+39', label: '🇮🇹 +39', flag: '🇮🇹', country: 'Italy' },
  { value: '+1-876', label: '🇯🇲 +1-876', flag: '🇯🇲', country: 'Jamaica' },
  { value: '+81', label: '🇯🇵 +81', flag: '🇯🇵', country: 'Japan' },
  { value: '+962', label: '🇯🇴 +962', flag: '🇯🇴', country: 'Jordan' },
  { value: '+7', label: '🇰🇿 +7', flag: '🇰🇿', country: 'Kazakhstan' },
  { value: '+254', label: '🇰🇪 +254', flag: '🇰🇪', country: 'Kenya' },
  { value: '+686', label: '🇰🇮 +686', flag: '🇰🇮', country: 'Kiribati' },
  { value: '+383', label: '🇽🇰 +383', flag: '🇽🇰', country: 'Kosovo' },
  { value: '+82', label: '🇰🇷 +82', flag: '🇰🇷', country: 'South Korea' },
  { value: '+965', label: '🇰🇼 +965', flag: '🇰🇼', country: 'Kuwait' },
  { value: '+996', label: '🇰🇬 +996', flag: '🇰🇬', country: 'Kyrgyzstan' },
  { value: '+856', label: '🇱🇦 +856', flag: '🇱🇦', country: 'Laos' },
  { value: '+371', label: '🇱🇻 +371', flag: '🇱🇻', country: 'Latvia' },
  { value: '+961', label: '🇱🇧 +961', flag: '🇱🇧', country: 'Lebanon' },
  { value: '+266', label: '🇱🇸 +266', flag: '🇱🇸', country: 'Lesotho' },
  { value: '+231', label: '🇱🇷 +231', flag: '🇱🇷', country: 'Liberia' },
  { value: '+218', label: '🇱🇾 +218', flag: '🇱🇾', country: 'Libya' },
  { value: '+423', label: '🇱🇮 +423', flag: '🇱🇮', country: 'Liechtenstein' },
  { value: '+370', label: '🇱🇹 +370', flag: '🇱🇹', country: 'Lithuania' },
  { value: '+352', label: '🇱🇺 +352', flag: '🇱🇺', country: 'Luxembourg' },
  { value: '+853', label: '🇲🇴 +853', flag: '🇲🇴', country: 'Macau' },
  { value: '+261', label: '🇲🇬 +261', flag: '🇲🇬', country: 'Madagascar' },
  { value: '+265', label: '🇲🇼 +265', flag: '🇲🇼', country: 'Malawi' },
  { value: '+60', label: '🇲🇾 +60', flag: '🇲🇾', country: 'Malaysia' },
  { value: '+960', label: '🇲🇻 +960', flag: '🇲🇻', country: 'Maldives' },
  { value: '+223', label: '🇲🇱 +223', flag: '🇲🇱', country: 'Mali' },
  { value: '+356', label: '🇲🇹 +356', flag: '🇲🇹', country: 'Malta' },
  { value: '+692', label: '🇲🇭 +692', flag: '🇲🇭', country: 'Marshall Islands' },
  { value: '+596', label: '🇲🇶 +596', flag: '🇲🇶', country: 'Martinique' },
  { value: '+222', label: '🇲🇷 +222', flag: '🇲🇷', country: 'Mauritania' },
  { value: '+230', label: '🇲🇺 +230', flag: '🇲🇺', country: 'Mauritius' },
  { value: '+52', label: '🇲🇽 +52', flag: '🇲🇽', country: 'Mexico' },
  { value: '+691', label: '🇫🇲 +691', flag: '🇫🇲', country: 'Micronesia' },
  { value: '+373', label: '🇲🇩 +373', flag: '🇲🇩', country: 'Moldova' },
  { value: '+377', label: '🇲🇨 +377', flag: '🇲🇨', country: 'Monaco' },
  { value: '+976', label: '🇲🇳 +976', flag: '🇲🇳', country: 'Mongolia' },
  { value: '+382', label: '🇲🇪 +382', flag: '🇲🇪', country: 'Montenegro' },
  { value: '+1', label: '🇲🇸 +1', flag: '🇲🇸', country: 'Montserrat' },
  { value: '+212', label: '🇲🇦 +212', flag: '🇲🇦', country: 'Morocco' },
  { value: '+258', label: '🇲🇿 +258', flag: '🇲🇿', country: 'Mozambique' },
  { value: '+95', label: '🇲🇲 +95', flag: '🇲🇲', country: 'Myanmar' },
  { value: '+264', label: '🇳🇦 +264', flag: '🇳🇦', country: 'Namibia' },
  { value: '+674', label: '🇳🇷 +674', flag: '🇳🇷', country: 'Nauru' },
  { value: '+977', label: '🇳🇵 +977', flag: '🇳🇵', country: 'Nepal' },
  { value: '+31', label: '🇳🇱 +31', flag: '🇳🇱', country: 'Netherlands' },
  { value: '+687', label: '🇳🇨 +687', flag: '🇳🇨', country: 'New Caledonia' },
  { value: '+64', label: '🇳🇿 +64', flag: '🇳🇿', country: 'New Zealand' },
  { value: '+505', label: '🇳🇮 +505', flag: '🇳🇮', country: 'Nicaragua' },
  { value: '+227', label: '🇳🇪 +227', flag: '🇳🇪', country: 'Niger' },
  { value: '+234', label: '🇳🇬 +234', flag: '🇳🇬', country: 'Nigeria' },
  { value: '+683', label: '🇳🇺 +683', flag: '🇳🇺', country: 'Niue' },
  { value: '+850', label: '🇰🇵 +850', flag: '🇰🇵', country: 'North Korea' },
  { value: '+389', label: '🇲🇰 +389', flag: '🇲🇰', country: 'North Macedonia' },
  { value: '+1', label: '🇲🇵 +1', flag: '🇲🇵', country: 'Northern Mariana Islands' },
  { value: '+47', label: '🇳🇴 +47', flag: '🇳🇴', country: 'Norway' },
  { value: '+968', label: '🇴🇲 +968', flag: '🇴🇲', country: 'Oman' },
  { value: '+92', label: '🇵🇰 +92', flag: '🇵🇰', country: 'Pakistan' },
  { value: '+680', label: '🇵🇼 +680', flag: '🇵🇼', country: 'Palau' },
  { value: '+970', label: '🇵🇸 +970', flag: '🇵🇸', country: 'Palestine' },
  { value: '+507', label: '🇵🇦 +507', flag: '🇵🇦', country: 'Panama' },
  { value: '+675', label: '🇵🇬 +675', flag: '🇵🇬', country: 'Papua New Guinea' },
  { value: '+595', label: '🇵🇾 +595', flag: '🇵🇾', country: 'Paraguay' },
  { value: '+51', label: '🇵🇪 +51', flag: '🇵🇪', country: 'Peru' },
  { value: '+63', label: '🇵🇭 +63', flag: '🇵🇭', country: 'Philippines' },
  { value: '+48', label: '🇵🇱 +48', flag: '🇵🇱', country: 'Poland' },
  { value: '+351', label: '🇵🇹 +351', flag: '🇵🇹', country: 'Portugal' },
  { value: '+1', label: '🇵🇷 +1', flag: '🇵🇷', country: 'Puerto Rico' },
  { value: '+974', label: '🇶🇦 +974', flag: '🇶🇦', country: 'Qatar' },
  { value: '+262', label: '🇷🇪 +262', flag: '🇷🇪', country: 'Réunion' },
  { value: '+40', label: '🇷🇴 +40', flag: '🇷🇴', country: 'Romania' },
  { value: '+7', label: '🇷🇺 +7', flag: '🇷🇺', country: 'Russia' },
  { value: '+250', label: '🇷🇼 +250', flag: '🇷🇼', country: 'Rwanda' },
  { value: '+590', label: '🇧🇱 +590', flag: '🇧🇱', country: 'Saint Barthélemy' },
  { value: '+290', label: '🇸🇭 +290', flag: '🇸🇭', country: 'Saint Helena' },
  { value: '+1-869', label: '🇰🇳 +1-869', flag: '🇰🇳', country: 'Saint Kitts and Nevis' },
  { value: '+1-758', label: '🇱🇨 +1-758', flag: '🇱🇨', country: 'Saint Lucia' },
  { value: '+590', label: '🇲🇫 +590', flag: '🇲🇫', country: 'Saint Martin (French)' },
  { value: '+508', label: '🇵🇲 +508', flag: '🇵🇲', country: 'Saint Pierre and Miquelon' },
  { value: '+1-784', label: '🇻🇨 +1-784', flag: '🇻🇨', country: 'Saint Vincent and the Grenadines' },
  { value: '+685', label: '🇼🇸 +685', flag: '🇼🇸', country: 'Samoa' },
  { value: '+378', label: '🇸🇲 +378', flag: '🇸🇲', country: 'San Marino' },
  { value: '+239', label: '🇸🇹 +239', flag: '🇸🇹', country: 'Sao Tome and Principe' },
  { value: '+966', label: '🇸🇦 +966', flag: '🇸🇦', country: 'Saudi Arabia' },
  { value: '+221', label: '🇸🇳 +221', flag: '🇸🇳', country: 'Senegal' },
  { value: '+381', label: '🇷🇸 +381', flag: '🇷🇸', country: 'Serbia' },
  { value: '+248', label: '🇸🇨 +248', flag: '🇸🇨', country: 'Seychelles' },
  { value: '+232', label: '🇸🇱 +232', flag: '🇸🇱', country: 'Sierra Leone' },
  { value: '+65', label: '🇸🇬 +65', flag: '🇸🇬', country: 'Singapore' },
  { value: '+1', label: '🇸🇽 +1', flag: '🇸🇽', country: 'Sint Maarten (Dutch)' },
  { value: '+421', label: '🇸🇰 +421', flag: '🇸🇰', country: 'Slovakia' },
  { value: '+386', label: '🇸🇮 +386', flag: '🇸🇮', country: 'Slovenia' },
  { value: '+677', label: '🇸🇧 +677', flag: '🇸🇧', country: 'Solomon Islands' },
  { value: '+252', label: '🇸🇴 +252', flag: '🇸🇴', country: 'Somalia' },
  { value: '+27', label: '🇿🇦 +27', flag: '🇿🇦', country: 'South Africa' },
  { value: '+211', label: '🇸🇸 +211', flag: '🇸🇸', country: 'South Sudan' },
  { value: '+34', label: '🇪🇸 +34', flag: '🇪🇸', country: 'Spain' },
  { value: '+94', label: '🇱🇰 +94', flag: '🇱🇰', country: 'Sri Lanka' },
  { value: '+249', label: '🇸🇩 +249', flag: '🇸🇩', country: 'Sudan' },
  { value: '+597', label: '🇸🇷 +597', flag: '🇸🇷', country: 'Suriname' },
  { value: '+46', label: '🇸🇪 +46', flag: '🇸🇪', country: 'Sweden' },
  { value: '+41', label: '🇨🇭 +41', flag: '🇨🇭', country: 'Switzerland' },
  { value: '+963', label: '🇸🇾 +963', flag: '🇸🇾', country: 'Syria' },
  { value: '+886', label: '🇹🇼 +886', flag: '🇹🇼', country: 'Taiwan' },
  { value: '+992', label: '🇹🇯 +992', flag: '🇹🇯', country: 'Tajikistan' },
  { value: '+255', label: '🇹🇿 +255', flag: '🇹🇿', country: 'Tanzania' },
  { value: '+66', label: '🇹🇭 +66', flag: '🇹🇭', country: 'Thailand' },
  { value: '+228', label: '🇹🇬 +228', flag: '🇹🇬', country: 'Togo' },
  { value: '+690', label: '🇹🇰 +690', flag: '🇹🇰', country: 'Tokelau' },
  { value: '+676', label: '🇹🇴 +676', flag: '🇹🇴', country: 'Tonga' },
  { value: '+1-868', label: '🇹🇹 +1-868', flag: '🇹🇹', country: 'Trinidad and Tobago' },
  { value: '+216', label: '🇹🇳 +216', flag: '🇹🇳', country: 'Tunisia' },
  { value: '+90', label: '🇹🇷 +90', flag: '🇹🇷', country: 'Turkey' },
  { value: '+993', label: '🇹🇲 +993', flag: '🇹🇲', country: 'Turkmenistan' },
  { value: '+290', label: '🇹🇦 +290', flag: '🇹🇦', country: 'Tristan da Cunha' },
  { value: '+1-649', label: '🇹🇨 +1-649', flag: '🇹🇨', country: 'Turks and Caicos Islands' },
  { value: '+688', label: '🇹🇻 +688', flag: '🇹🇻', country: 'Tuvalu' },
  { value: '+256', label: '🇺🇬 +256', flag: '🇺🇬', country: 'Uganda' },
  { value: '+380', label: '🇺🇦 +380', flag: '🇺🇦', country: 'Ukraine' },
  { value: '+971', label: '🇦🇪 +971', flag: '🇦🇪', country: 'United Arab Emirates' },
  { value: '+44', label: '🇬🇧 +44', flag: '🇬🇧', country: 'United Kingdom' },
  { value: '+1', label: '🇺🇸 +1', flag: '🇺🇸', country: 'United States' },
  { value: '+598', label: '🇺🇾 +598', flag: '🇺🇾', country: 'Uruguay' },
  { value: '+998', label: '🇺🇿 +998', flag: '🇺🇿', country: 'Uzbekistan' },
  { value: '+678', label: '🇻🇺 +678', flag: '🇻🇺', country: 'Vanuatu' },
  { value: '+39', label: '🇻🇦 +39', flag: '🇻🇦', country: 'Vatican City' },
  { value: '+58', label: '🇻🇪 +58', flag: '🇻🇪', country: 'Venezuela' },
  { value: '+84', label: '🇻🇳 +84', flag: '🇻🇳', country: 'Vietnam' },
  { value: '+1', label: '🇻🇮 +1', flag: '🇻🇮', country: 'US Virgin Islands' },
  { value: '+681', label: '🇼🇫 +681', flag: '🇼🇫', country: 'Wallis and Futuna' },
  { value: '+967', label: '🇾🇪 +967', flag: '🇾🇪', country: 'Yemen' },
  { value: '+260', label: '🇿🇲 +260', flag: '🇿🇲', country: 'Zambia' },
  { value: '+263', label: '🇿🇼 +263', flag: '🇿🇼', country: 'Zimbabwe' },
];

